<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <!--
      <b-link class="navbar-brand" to="/dashboard" href="http://www.agulhasnegras.com.br" target="_blank">
      -->
      <b-link class="navbar-brand" :to="this.$store.state.config.mainUrl">
        <img class="navbar-brand-full logo-fit" :src="this.$store.getters.currentLogo">
        <img class="navbar-brand-minimized" :src="this.$store.state.config.logoSmall" :width="this.$store.state.config.logoSmallDim.width" :height="this.$store.state.config.logoSmallDim.height">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
        
        <b-nav-item class="px-3" to="/controlpanel">Área de Trabalho</b-nav-item>
        <b-nav-item class="px-3" to="/users" exact v-if="$store.state.currentUser.access" >Usuários</b-nav-item>
        <b-nav-item class="px-3" v-if="$store.state.currentUser.access" >Configurações</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        
        <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdownNotif :obj="notificationList"/>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdownTasks :obj="taskList"/>
        </b-nav-item>
        <b-nav-item class="d-lg-down-none">
          <DefaultHeaderDropdownMssgs :obj="messageList"/>
        </b-nav-item>
        <!--
        <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdown/>
        </b-nav-item>
        -->
        <b-nav-item-dropdown class="d-md-down-none" no-caret right menu-class="theme-dropdown-menu">
          <template slot="button-content">
            <i :class="themeIcon" :title="'Tema: ' + themeLabel" style="font-size:1.1rem"></i>
          </template>
          <b-dropdown-header>Tema</b-dropdown-header>
          <b-dropdown-item v-for="t in themes" :key="t.id" @click="setTheme(t.id)" :active="$store.state.theme === t.id">
            <i :class="t.icon" class="mr-2"></i> {{ t.label }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
        
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <AsideToggler class="d-none d-lg-block" v-if="!$store.state.currentUser.access" />
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div class="ml-auto">
        <a href="https://www.a6i.com.br">SMG</a>
        <span class="ml-1">&reg; {{ this.$store.state.config.copyright }} {{ this.$store.state.config.year }}</span>
      </div>      
    </TheFooter>
  </div>
</template>

<script>
//import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdown from './DefaultHeaderDropdown'
import DefaultHeaderDropdownNotif from './DefaultHeaderDropdownNotif'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import DefaultHeaderDropdownMssgs from './DefaultHeaderDropdownMssgs'
import DefaultHeaderDropdownTasks from './DefaultHeaderDropdownTasks'
import axios from "axios";

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    DefaultHeaderDropdownMssgs,
    DefaultHeaderDropdownNotif,
    DefaultHeaderDropdownTasks,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      intervalId: null,
      themes: [
        { id: 'light',     label: 'Claro',     icon: 'fa fa-sun-o' },
        { id: 'dark',      label: 'Escuro',    icon: 'fa fa-moon-o' },
        { id: 'shockwave', label: 'Shockwave', icon: 'fa fa-bolt' },
//        { id: 'bmw',       label: 'BMW',       icon: 'fa fa-car' }
      ],
      // MENU POR ARQUIVO
      //nav: nav.items,
      nav: this.$store.state.menu,
      //notificationList: [],
      //taskList: [],
      //messageList: [],
      messages: [ /*
        {
          id: 0,
          message: {
            subject: 'Teste',
            messageDate: Date(),
            user: {
              name: 'Alexandre'
            }
          }
        }
        */
      ]
    }
  },
  computed: {
    themeIcon() {
      const icons = { light: 'fa fa-sun-o', dark: 'fa fa-moon-o', shockwave: 'fa fa-bolt', bmw: 'fa fa-car' };
      return icons[this.$store.state.theme] || 'fa fa-moon-o';
    },
    themeLabel() {
      const labels = { light: 'Claro', dark: 'Escuro', shockwave: 'Shockwave', bmw: 'BMW' };
      return labels[this.$store.state.theme] || 'Escuro';
    },
    notificationList() {
      var s = this
      return s.messages.filter(item => {
        return (item.message && item.message.typeId == 3)
      })
    },
    taskList() {
      var s = this
      return s.messages.filter(item => {
        return (item.message && item.message.typeId == 4)
      })
    },
    messageList() {
      var s = this
      return s.messages.filter(item => {
        return (item.message && item.message.typeId == 1)
      })
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  watch: {
    '$store.state.menu': {
        immediate: true,
        handler() {
          // MENU PRINCIPAL DO SISTEMA
          // MENU DO SISTEMA

           const cookieMenu = this.$store.state.config.storageName
           this.nav = this.$store.state.menu;
           
           // Só tenta recuperar dados se não houver usuário logado
           if(!this.$store.state.currentUser || !this.$store.state.currentUser.id ) {   

              // Recupera dados dos usuário
              //var currentUser = this.$cookies.get("smg_user")
              var currentUser = null
              var currentUserString = localStorage.getItem(cookieMenu + '_USER')
              if(currentUserString) {
                currentUser = JSON.parse(currentUserString)
              }
              
              if(currentUser && currentUser.id && currentUser.id > 0) {
                //console.log("Recuperando dados do usuário e menu - Aguarde...")
                this.$store.commit('SET_CURRENT_USER', currentUser);
                //console.log("Recuperando menu de: " + cookieMenu + "_MENU")
                var recoveredMenu = localStorage.getItem(cookieMenu + '_MENU')
                if(recoveredMenu) {
                  this.$store.commit('SET_MENU',JSON.parse(recoveredMenu));
                }
              }
             
           }
        }
     }
  },
  methods: {
      setTheme(id) {
        this.$store.commit('SET_THEME', id);
      },
      async getMessages() {
        var s = this
        var currentUser = s.$store.state.currentUser;

        if(currentUser && currentUser.id > 0) {
          var url = s.$store.state.ws_url + "/message/user?uid=" + currentUser.id + "&sid=" + currentUser.sid
          await axios.get(
              url
          ).then(function(resp) {
            s.messages = resp.data.obj 
          })
          .catch(function(error) {
              console.log(error);
          }); 
        }
    },
    
    getSyncData() {
      this.getMessages()
    }
  },
  mounted: function () {
    const refreshTime = this.$store.state.config.notificationRefresh
    this.getSyncData()

    if(!this.intervalId) {
      //this.intervalId = setInterval(this.getSyncData, refreshTime ? refreshTime : 60000 )
    }
  },
  beforeDestroy: function() {
    //clearInterval(this.intervalId)
  }
}




</script>

<style>
.navbar-brand .logo-fit {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}
.theme-dropdown-menu {
  min-width: 200px;
  width: 200px;
}
.theme-dropdown-menu .dropdown-item {
  white-space: nowrap;
}
</style>
